/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SaveNotificationEmailRequest
 */
export interface SaveNotificationEmailRequest {
  /**
   * Список email-адресов (до 7, без дубликатов)
   * @type {Array<string>}
   * @memberof SaveNotificationEmailRequest
   */
  emails?: Array<string>
}

/**
 * Check if a given object implements the SaveNotificationEmailRequest interface.
 */
export function instanceOfSaveNotificationEmailRequest(
  value: object
): value is SaveNotificationEmailRequest {
  return true
}

export function SaveNotificationEmailRequestFromJSON(
  json: any
): SaveNotificationEmailRequest {
  return SaveNotificationEmailRequestFromJSONTyped(json, false)
}

export function SaveNotificationEmailRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SaveNotificationEmailRequest {
  if (json == null) {
    return json
  }
  return {
    emails: json['emails'] == null ? undefined : json['emails'],
  }
}

export function SaveNotificationEmailRequestToJSON(
  value?: SaveNotificationEmailRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    emails: value['emails'],
  }
}
